import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-gray-100 py-6">
      <div className="max-w-screen-xl mx-auto flex flex-col items-center justify-center text-center space-y-2 px-4">
        {/* Logo */}
        <img
          src="/logo_iword.png"
          alt="Iword Hosting"
          className="h-5 w-auto"
        />

        {/* Copyright */}
        <p className="text-xs text-gray-500">
          Made with <span className="text-red-500">❤️</span> — © 2009 - 2025 Iword Hosting. All rights reserved.
        </p>

        {/* Footer Links */}
        <div className="flex space-x-4 text-xs">
          <Link to="/terms" className="text-gray-500 hover:text-gray-700">Terms</Link>
          <Link to="/privacy" className="text-gray-500 hover:text-gray-700">Privacy</Link>
          <Link to="/sitemap" className="text-gray-500 hover:text-gray-700">Sitemap</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
